import {
  Card as CardMaterialUI,
  CardContent,
  Tooltip,
} from "@material-ui/core";
import { Avatar, ListItem as ListItemMUI, Typography } from "@material-ui/core";
import styled, { css } from "styled-components";
import { CheckCircle } from "@material-ui/icons";
import { ReactComponent as FavoriteCheckedIcon } from "../../../assets/icons/star-checked.svg";

export const ListItem = styled(ListItemMUI).attrs({
  style: {
    paddingTop: 4,
    paddingBottom: 4,
    paddingRight: 0,
    paddingLeft: 0,
    width: 375,
  },
})`
  ${(props) =>
    props.$isSelected &&
    css`
      background-color: #d3d3d3;
    `}
`;

export const AvatarTooltip = styled(Tooltip)``;

export const ContactAvatar = styled(Avatar)`
  width: 48px;
  height: 48px;
`;

export const CheckedAvatar = styled(CheckCircle)`
  width: 48px;
  height: 48px;
  color: #31a862;
`;

export const Card = styled(CardMaterialUI)`
  width: 100%;
  box-shadow: none;
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.09);
  border-radius: 0px;
  margin: -4px 12px;
  padding: 4px;
  height: 92px;

  ${(props) =>
    props.status === "filed" &&
    `
    opacity:0.5;
  `}

  ${(props) =>
    props.$isSelected &&
    css`
      background-color: #d3d3d3;
    `}
`;

export const ContactName = styled(Typography)`
  font-size: 14px;
  font-weight: bold;
  width: 150px;
`;

export const ContactStatus = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: baseline;
`;

export const ContactUpdatedAt = styled(Typography)`
  font-size: 10px;
  color: #999999;
`;

export const LastMessageInfo = styled(Typography)`
  font-size: 14px;
  width: 80%;
  color: #777777;
  line-height: 17.41px;

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  max-height: 1 * 2;
  white-space: break-spaces;
  word-break: break-all;
`;

export const LastActivity = styled(Typography)`
  font-size: 12px;
  width: 60%;

  ${(props) =>
    props.$isFutureDate
      ? css`
          color: var(--primary);
        `
      : css`
          color: var(--danger);
        `}
`;

export const ContactOwner = styled.div`
  width: 40%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const ContactOwnerName = styled(Typography)`
  font-size: 12px;
  font-weight: bold;
  text-align: right;
`;

export const FavoriteIcon = styled(FavoriteCheckedIcon).attrs({
  stroke: "#d9d9d9",
})`
  width: 18px;
  height: 18px;
  margin-left: 4px;
  position: absolute;
  border: 1px;
  left: 42px;
  top: 3px;
`;

export const CardFooterInfo = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 7px;
  width: 100%;
`;
export const CardInfo = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

export const Col = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-left: 5px;
  width: 100%;
`;

export const ContainerInfos = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  text-overflow: ellipsis;
  word-wrap: break-word;
  overflow: hidden;
`;

export const Content = styled(CardContent)`
  padding: 10px;
  width: 100%;

  span {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0em;
    text-align: left;
    color: #999999;
  }

  .customer-name {
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 19px;
    margin-bottom: 5px;
    color: #444444;

    .is-favorite {
      position: relative;
      top: 2px;
      left: 5px;
    }
  }

  .customer-user {
    text-align: right;
  }
`;

export const UnReadMessages = styled.div`
  width: 20px;
  height: 20px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--primary);
  color: rgb(255, 255, 255);
  border-radius: 50%;
`;
